import { EGDSLayoutGridItem } from '@egds/react-core/layout-grid';
import { ExperienceTemplateRenderer } from 'experience-template-renderer-react';
import * as React from 'react';
import { number, object, optional, safeParse } from 'valibot';
export const LayoutGridItem = ({
  templateComponent
}) => {
  var _a;
  const {
    children,
    config
  } = templateComponent;
  const configSchema = optional(object({
    colSpan: number()
  }));
  const result = safeParse(configSchema, config);
  if (!result.success || !children || children.length === 0) {
    return null;
  }
  const {
    colSpan
  } = (_a = result.output) !== null && _a !== void 0 ? _a : {};
  return React.createElement(EGDSLayoutGridItem, {
    colSpan: colSpan
  }, React.createElement("div", null, children && React.createElement(ExperienceTemplateRenderer, {
    templateComponents: children
  })));
};